<template>
    <div>
        <md-dialog :md-active.sync="show" style="" class="holiday-dialog">
            <div class="horizontal-wrapper" style="flex: 0 0 auto;">
                <md-dialog-title style="display: inline">QR Code info</md-dialog-title>
                
                <md-dialog-actions>
                    <md-button class="md-primary" v-on:click="$router.go(-1)" >Close</md-button>
                    <md-button class="md-primary" v-on:click="save" >Save</md-button>
                </md-dialog-actions>
            </div>

            <div class="vertical-wrapper" style="margin: 0 5pt">
                <h2>Organisation</h2>
                <div class="horizontal-wrapper" style="flex: 0 0 auto">
                    <md-field >
                        <label>Firma</label>
                        <md-input v-model="company"></md-input>
                    </md-field>
                </div>

                <h2>Name</h2>
                <div class="horizontal-wrapper" style="flex: 0 0 auto">
                    <md-field >
                        <label>Name</label>
                        <md-input v-model="name"></md-input>
                    </md-field>
                    <div style="flex: 0 0 5pt"></div>
                    <md-field >
                        <label>Nachname</label>
                        <md-input v-model="surname"></md-input>
                    </md-field>
                </div>

                <h2>Kontakt</h2>
                <div class="horizontal-wrapper" style="flex: 0 0 auto">
                    <md-field >
                        <label>Telefon</label>
                        <md-input v-model="phone"></md-input>
                    </md-field>
                    <div style="flex: 0 0 5pt"></div>
                    <md-field >
                        <label>E-mail</label>
                        <md-input v-model="email"></md-input>
                    </md-field>
                </div>
            </div>

        
    </md-dialog>
    </div>
</template>
<script>
export default {
    name: 'qr-code-access-info-view',
    methods:{
        save(){
            this.$socket.emit('set-qr-code-access-info', {token: this.token, qrcode: this.qrcode, customerInfo:{
                    name: this.name, 
                    surname: this.surname, 
                    phone:this.phone, 
                    email: this.email,
                    company: this.company
                }})
        }
    },
    beforeRouteEnter (to, from, next) { 
        next(vm => { 
            vm.show = true
            next();
        }) 
    },
    computed:{
        token(){
            return this.$store.getters.token
        },
        qrcode(){
            return this.$store.state.qrcode
        }
    },
    sockets:{
        'set-qr-code-access-info':function(customerInfo){
            this.name = customerInfo.name;
            this.surname = customerInfo.surname;
            this.phone = customerInfo.phone;
            this.email = customerInfo.email;
            this.company = customerInfo.company

        },
        
    },
    data(){
        return{
            show: false,

            name: '',
            surname: '',
            phone: '',
            email: '',
            company: ''
        }
    }
}
</script>